import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { successToast, errorToast } from "../../../utils/helper";
import { getApiServices } from "../../../apis/api";
import { apiRoutes } from "../../../apis/apiPath";
import { store } from "../../../redux/Store";
import { setUserData } from "../../../redux/MainReducer";
import { ROUTE_PATHS } from "../../../routes/routePath";

const TwoFALogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const cookies = new Cookies();

  useEffect(() => {
    const token = searchParams.get("token");
    const tenant = searchParams.get("tenant");

    if (!token) {
      errorToast("Invalid 2FA link");
      return;
    }

    // ✅ Fixed URL query string (added "&" between token and tenant)
    getApiServices(`${apiRoutes.twoFALogin}?token=${token}&tenant=${tenant}`)
      .then(({ data }) => {
        if (!data?.token) {
          errorToast("Invalid or expired 2FA link");
          return;
        }

        // ✅ Set cookies
        cookies.set("token", data?.token, { path: "/" });
        cookies.set("userId", data?.userId, { path: "/" });
        cookies.set("userFullName", data?.userFullName, { path: "/" });
        cookies.set("defaultcompany", data?.defaultcompany, { path: "/" });
        cookies.set("userEmail", data?.userEmail, { path: "/" });
        cookies.set("isTenantAdmin", data?.isTenantAdmin, { path: "/" });
        cookies.set("activeSubscription", data?.activeSubscription, { path: "/" });
        cookies.set('tenantEnabled', data.tenantEnabled ?? true, { path: '/' })
        // ✅ Save to redux
        store.dispatch(setUserData({ ...data }));

        successToast("Login successful!");
        if (data.defaulttenant) {
          navigate(ROUTE_PATHS.COMPANY_LIST);
        } else {
          navigate(ROUTE_PATHS.HOME);
        }
      })
      .catch(() => errorToast("Invalid or expired 2FA link"));
  }, []);

  return <p>Completing login...</p>;
};

export default TwoFALogin;
